var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<strong ng-transclude=\"label\" class=\"{{::$ctrl.labelClass}} text-{{::$ctrl.labelColor || 'default'}}\"><span>{{::$ctrl.label + ($ctrl.label?':':'')}}&nbsp;</span> </strong><span ng-transclude=\"\" class=\"{{::$ctrl.valueClass}} text-{{::$ctrl.valueColor || 'default'}}\">{{$ctrl.value}} </span><span ng-transclude=\"value\" class=\"{{::$ctrl.valueClass}} text-{{::$ctrl.valueColor || 'default'}}\"></span>";
var id1="datum-inline.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;